import Fire from './fire.service'

import moment from 'moment'
import 'moment/locale/fr'

export default class Time {

  static moment(val: any) {
    return moment(val)
  }

  static fireDate(req: any) {
    const date = req ? Fire.getDateFor(req) : new Date()
    return moment(date)    
  }

  static renderDay(req: any) {
    const date = req ? Fire.getDateFor(req) : new Date()
    return moment(date).format('dddd, DD MMMM')
  }
  static renderDayWithNumbers(req: any) {
    const date = req ? Fire.getDateFor(req) : new Date()
    return moment(date).format('DD/MM/YYYY')
  }

  static renderDate(req: any) {
    const date = req ? Fire.getDateFor(req) : new Date()
    return moment(date).format('dddd, DD MMMM - HH:mm:ss')
  }

  static eventDate(event: any) {

    const date = event.dateStart ? Fire.getDateFor(event.dateStart) : new Date()
    return moment(date).format('dddd, DD MMMM')
  }
}